import React from "react";

import Context from "../../../context/Context";
import * as component from "../../../components/util/component";

import Form, {
  Fieldset,
  FormControl,
  FormControlLabel,
  Legend
} from "calcite-react/Form";
import Radio from "calcite-react/Radio";
import TextField from "calcite-react/TextField";

export default class VersionProperties extends React.Component {
  componentId;

  constructor(props) {
    super(props);
    this.componentId = component.nextId();
    this.state = component.newState({
      title: "",
      summary: "",
      access: "private" // private | public | protected | hidden
    });
    this.onChangeAccess_Private = this.onChangeAccess_Private.bind(this);
    this.onChangeAccess_Protected = this.onChangeAccess_Protected.bind(this);
    this.onChangeAccess_Public = this.onChangeAccess_Public.bind(this);
    this.onChangeSummary = this.onChangeSummary.bind(this);
  }

  componentDidMount() {
    if (typeof this.props.onMount === "function") this.props.onMount(this);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  getItemInfo() {
    const state = this.state;
    return {
      title: state.title.trim(),
      description: state.summary.trim(),
      accessPermission: state.access
    };
  }

  onChangeAccess_Private(evt) {
    this.setState({ access: "private" });
  }

  onChangeAccess_Protected(evt) {
    this.setState({ access: "protected" });
  }

  onChangeAccess_Public(evt) {
    this.setState({ access: "public" });
  }

  onChangeSummary(evt) {
    this.setState({ summary: evt.target.value });
  }

  onChangeTitle = evt => {
    this.setState({ title: evt.target.value });
  };

  onSubmit = (evt) => {
    if (evt) evt.preventDefault();
    if (evt) evt.stopPropagation();
    if (this.props.submitHandle) {
      const title = this.state.title.trim();
      if (title.length > 0) {
        this.props.submitHandle();
      }
    }
  };

  render() {
    const i18n = Context.instance.i18n;
    const id = this.componentId;
    const horizontal = true;
    const cls = horizontal ? "i--form i--form-horizontal" : "i--form";
    const title = this.state.title;
    const summary = this.state.summary;
    const access = this.state.access;

    /*
    if (showAccess) {
      accessNode = (
        <FormControl horizontal={horizontal}>
          <Fieldset name="sharingOptions">
            <Legend className="i--form-label">
              {i18n.configurator.appItem.shareWith.caption}
            </Legend>
            <Radio
              value="private"
              defaultChecked={access === "private"}
              onChange={this.onChangeAccess_Private}
            >
              {i18n.configurator.appItem.shareWith.private}
            </Radio>
            <Radio
              value="protected"
              defaultChecked={access === "protected"}
              onChange={this.onChangeAccess_Protected}
            >
              {i18n.configurator.appItem.shareWith.organization}
            </Radio>
            <Radio
              value="public"
              defaultChecked={access === "public"}
              onChange={this.onChangeAccess_Public}
            >
              {i18n.configurator.appItem.shareWith.everyone}
            </Radio>
          </Fieldset>
        </FormControl>
      );
    }
    */

    return (
      <Form className={cls} onSubmit={this.onSubmit}>
        <FormControl horizontal={horizontal}>
          <FormControlLabel
            id={id + "-title-label"}
            htmlFor="title"
            className="i--form-label"
          >
            <span className="i--required">
              {i18n.configurator.appItem.title}
            </span>
          </FormControlLabel>
          <TextField
            id={id + "-title"}
            defaultValue={title}
            type="text"
            fullWidth={true}
            maxLength="62"
            placeholder={i18n.spaceplanner.backstage.newPlan.placeholder}
            onChange={this.onChangeTitle}
          />
        </FormControl>

        <FormControl horizontal={horizontal}>
          <FormControlLabel
            id={id + "-summary-label"}
            htmlFor="summary"
            className="i--form-label"
          >
            {i18n.configurator.appItem.summary}
          </FormControlLabel>
          <TextField
            id={id + "-summary"}
            defaultValue={summary}
            type="textarea"
            fullWidth={true}
            maxLength="62"
            placeholder={i18n.spaceplanner.backstage.newPlan.placeholder}
            onChange={this.onChangeSummary}
          />
        </FormControl>

        <FormControl horizontal={horizontal}>
          <Fieldset name="sharingOptions">
            <Legend className="i--form-label">
              {i18n.configurator.appItem.shareWith.caption}
            </Legend>
            <Radio
              value="private"
              defaultChecked={access === "private"}
              onChange={this.onChangeAccess_Private}
            >
              {i18n.configurator.appItem.shareWith.private}
            </Radio>
            <Radio
              value="public"
              defaultChecked={access === "public"}
              onChange={this.onChangeAccess_Public}
            >
              {i18n.configurator.appItem.shareWith.organization}
            </Radio>
          </Fieldset>
        </FormControl>

      </Form>
    );
  }
}
